import { render, staticRenderFns } from "./addqueue.vue?vue&type=template&id=3f8d29f8"
import script from "./addqueue.vue?vue&type=script&lang=js"
export * from "./addqueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports